<nb-card style="height: 100%;">
  <nb-card-header>
    <div class="row">
      <h3 class="col-sm-8">Contracts</h3>
      <!-- <div class="col-sm-2">
        <button style="width: 100%" mat-raised-button (click)="this.downloadBuildList()" [nbSpinner]="this.isDownloading" [nbSpinnerMessage]="'Printing...'">Print Build List</button>
      </div>
      <div class="col-sm-2" [nbSpinner]="!this.isDownloading" [nbSpinnerMessage]="'Printing...'">
        <button style="width: 100%" mat-raised-button (click)="this.printPickList()">Print Picklist</button>
      </div> -->
    </div>
  </nb-card-header>
  <nb-card-body [nbSpinner]="isLoading">
    <div class="row">
      <div class="col-lg-2 col-12">
        <!-- Customer -->
        <mat-form-field style="width: 100%;">
          <input matInput type="text" placeholder="Customer" [(ngModel)]="searchCustomer" (keyup.enter)="onSearch()">
        </mat-form-field>
      </div>
      <div class="col-lg-2 col-12">
        <!-- Contract Type -->
        <mat-form-field style="width: 100%;">
          <input matInput type="text" placeholder="Contract Type" [(ngModel)]="searchContractType" (keyup.enter)="onSearch()">
        </mat-form-field>
      </div>
      <div class="col-lg-2 col-12">
        <!-- Contract Year -->
        <mat-form-field style="width: 100%;">
          <input matInput type="text" placeholder="Contract Year" [(ngModel)]="searchContractYear" (keyup.enter)="onSearch()">
        </mat-form-field>
      </div>
      <div class="col-lg-2 col-12">
        <!-- Status -->
        <mat-form-field style="width: 100%;">
          <input matInput type="text" placeholder="Status" [(ngModel)]="searchStatus" (keyup.enter)="onSearch()">
        </mat-form-field>
      </div>
      <div class="col-lg-2 col-12">
        <!-- Sales Rep -->
        <mat-form-field style="width: 100%;">
          <input matInput type="text" placeholder="Sales Rep" [(ngModel)]="searchSalesRep" (keyup.enter)="onSearch()">
        </mat-form-field>
      </div>

      <!-- <div class="col-lg-2 col-12">
        <mat-form-field class="select-form">
          <mat-select 
            placeholder="Status" 

            multiple
            name="selectedStatuses"
            class="filter-select"
            [(ngModel)]="this.searchStatuses"
            multiple
            #statusSelect="ngModel"
            (selectionChange)="selectAllStatuses();">
            <mat-option *ngFor="let x of this.statuses" [value]="x">
              {{x}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
      <!-- DATE -->
      <!-- <div class="col-lg-2 col-12" style="white-space: nowrap;">
        <label style="color: #8b8b8b; font-weight: normal;
          margin-top: 19px; cursor: pointer;">
          <input  class="dateTimeInput" [(ngModel)]="selectedDate" (ngModelChange)="onChange()"
            [owlDateTimeTrigger]="dt"
            placeholder="Ship Date" [owlDateTime]="dt">
          <span class="trigger" [owlDateTimeTrigger]="dt">
            <fa-icon style="margin-left: 3px;" [icon]="faCalendarAlt"
              size="lg"></fa-icon>
          </span>
          <owl-date-time [pickerType]="'calendar'" #dt></owl-date-time>
        </label>
      </div> -->

      <div class="col-lg-2 col-12 d-flex align-items-center ">
        <button mat-button aria-label="Search" (click)="onSearch();" class="me-2">
          Search <fa-icon [icon]="faSearch"></fa-icon>
        </button>
      </div>
    </div>

    <div class="mat-elevation-z0">
      <table mat-table class="full-width-table" [dataSource]="dataSource" matSort multiTemplateDataRows
      aria-label="Elements">

        <!-- Flag -->
        <ng-container matColumnDef="flag">
          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td (click)="flagOrder(row, $event.stopPropagation());" mat-cell *matCellDef="let row"
          [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
            <fa-icon [ngClass]="{'red':!row.isLocked, 'blue':row.isLocked }" style="margin-left: 5px;" [icon]="faFlag" size="lg">
            </fa-icon>
          </td>
        </ng-container>

        <!-- customerName -->
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
          <td  mat-cell *matCellDef="let row" [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
            {{row.customerName}}
          </td>
        </ng-container>

        <!-- Contract Type -->
        <ng-container matColumnDef="contractType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract Type</th>
          <td  mat-cell *matCellDef="let row" [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
            {{row.contractTemplateName}}
          </td>
        </ng-container>

        <!-- Contract Year -->
        <ng-container matColumnDef="contractYear">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract Year</th>
          <td  mat-cell *matCellDef="let row" [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
            {{row.contractYear}}
          </td>
        </ng-container>

        <!-- Expiration Date -->
        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</th>
          <td  mat-cell *matCellDef="let row"  [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
            <div *ngIf="row.expirationDate != '0001-01-01T00:00:00Z'">
              {{row.expirationDate | date: 'MMM d, y' }}
            </div> 
          </td>
        </ng-container>

        <!-- Effective Date -->
        <ng-container matColumnDef="effectiveDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Effective Date</th>
          <td  mat-cell *matCellDef="let row"  [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
            <div *ngIf="row.effectiveDate != '0001-01-01T00:00:00Z'">
              {{row.effectiveDate | date: 'MMM d, y'}}
            </div> 
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let row" [ngClass]="row.isLocked ? 'backgroundFlag' : ''">{{row.contractStatus}}</td>
        </ng-container>
        
        <!-- Sales Rep -->
        <ng-container matColumnDef="salesRep">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Rep</th>
          <td mat-cell *matCellDef="let row" [ngClass]="row.isLocked ? 'backgroundFlag' : ''">{{row.salesRepName}}</td>
        </ng-container>

        <!-- Edit Button -->
        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
          <td (click)="row.isLocked || navigateToContractEdit(row, $event.stopPropagation());" mat-cell *matCellDef="let row" [ngClass]="row.isLocked? 'backgroundFlag' : ''">
            <fa-icon [ngClass]="row.isLocked ? 'disabled-icon' : ''" class="eyeColor" style="margin-left: 5px;" [icon]="faEdit" size="sm"></fa-icon>
          </td>
        </ng-container>

        <!-- Upload Button -->
        <ng-container matColumnDef="upload">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload File</th>
          <td [attr.disabled]="row.isLocked" (click)="row.isLocked || openFileUpload(row, $event.stopPropagation());" mat-cell *matCellDef="let row" [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
            <!-- <input type="file" ng2FileSelect [uploader]="uploader"/>   -->
            <fa-icon [ngClass]="row.isLocked ? 'disabled-icon' : ''" class="eyeColor" style="margin-left: 5px;" [icon]="faFileUpload" size="sm"></fa-icon>
            <!-- <input type="file" ng2FileSelect [uploader]="uploader" />
            <button type="button" class="btn btn-success btn-s" (click)="uploader.uploadAll()">
              Upload
            </button> -->
            <!-- <input type="file" (change)="fileUpload($event)"> -->
            <!-- <ngx-dropzone  (change)="onFileUpload($event)"></ngx-dropzone> -->
            <!-- <ngx-dropzone (change)="onFileUpload($event)">
              <ngx-dropzone-label>Drop/Upload File</ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone> -->
          </td>
        </ng-container>

        <!-- Ammend Contract -->
        <ng-container matColumnDef="ammend">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Ammend</th>
          <td [attr.disabled]="row.isLocked" (click)="goToContractAmmend(row, $event.stopPropagation());" mat-cell *matCellDef="let row" [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
              <fa-icon [ngClass]="row.isLocked ? 'disabled-icon' : ''" class="eyeColor" style="margin-left: 5px;" [icon]="faClone" size="sm"></fa-icon>
          </td>
        </ng-container>

        <!-- View Contract -->
        <ng-container matColumnDef="view">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>View</th>
          <td  (click)="viewContract(row, $event.stopPropagation());" mat-cell *matCellDef="let row" [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
              <fa-icon [ngClass]="row.isLocked ? 'disabled-icon' : ''" class="eyeColor" style="margin-left: 5px;" [icon]="faEye" size="sm"></fa-icon>
          </td>
        </ng-container>

         <!-- Delete Contract -->
         <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Delete</th>
          <td [attr.disabled]="row.isLocked" (click)="row.isLocked || showConfirmation(row, $event.stopPropagation());" mat-cell *matCellDef="let row" [ngClass]="row.isLocked ? 'backgroundFlag' : ''">
              <fa-icon [ngClass]="row.isLocked ? 'disabled-icon' : ''" class="eyeColor" style="margin-left: 5px;" [icon]="faTrash" size="sm"></fa-icon>
          </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
            <div class="example-element-detail" [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">
              <div class="row" style="margin-left: 0; margin-right: 0;">

                <mat-divider style="width: 100%;"></mat-divider>

                <!-- table -->
                <div class="col-lg-12 col-12" style="padding: 0px; margin-bottom: 50px;">
                  <table class="table" style="min-width: 80vw;">
                    <thead>
                      <tr>
                        <!-- <th>
                          <h6>Variety</h6>
                        </th> -->
                        <th>
                          <h6>Product</h6>
                        </th>
                        <!-- <th>
                          <h6>Crop Year</h6>
                        </th> -->
                        <th>
                          <h6>Quantity</h6>
                        </th>
                        <th>
                          <h6>U/M</h6>
                        </th>
                        <th>
                          <h6>Price/Unit</h6>
                        </th>
                        <th>
                          <h6>Currency</h6>
                        </th>
                        <!-- <th>
                          <h6>Pkg. Type</h6>
                        </th> -->
                        <th>
                          <h6>Total</h6>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of row.contractLine">
                        <!-- <td class="tdWidth">
                          <h6>{{l.varietyName}}</h6>
                        </td> -->
                        <td class="tdWidth">
                          <h6>{{l.inventoryItemName}}</h6>
                        </td>
                        <!-- <td class="tdWidth">
                          <h6>{{l.cropYear}}</h6>
                        </td> -->
                        <td class="tdWidth">
                          <h6>{{l.quantity}}</h6>
                        </td>
                        <td class="tdWidth">
                          <h6>{{l.unitOfMeasure}}</h6>
                        </td>
                        <td class="tdWidth">
                          <h6>{{l.price | currency}}</h6>
                        </td>
                        <td class="tdWidth">
                          <h6>{{l.currency}}</h6>
                        </td>
                        <!-- <td class="tdWidth">
                          <h6>{{l.packageName}}</h6>
                        </td> -->
                        <!-- <td class="tdWidth">
                          <h6>{{l.quantity}}</h6>
                        </td> -->
                        <td class="tdWidth">
                          <h6>{{(l.price * l.quantity) | currency}}</h6>
                          <!-- <h6 *ngIf="this.authService.hasRole('hollingbery:ar-user') && l.packageType === 0 && l.itemNumber === 'CC Fee' || l.itemNumber === 'Bag Fee'">
                            {{l.price | currency}}</h6> -->
                        </td>
                      </tr>
                    </tbody>
                    <tfoot >
                      <tr style="background-color: lightgoldenrodyellow;">
                        <td>
                          <h6>Total:</h6>
                        </td>
                        <!-- <td></td>
                        <td></td> -->
                        <td>
                          <h6>{{getTotalQty(row.contractLine)}}</h6>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <!-- <td></td> -->
                        <td>
                          <h6>{{getSubtotal(row.contractLine) | currency}}</h6>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </td>
        </ng-container>
        <tr class="tableHeader" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->

        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row example-element-row"
          [class.example-expanded-row]="expandedElement === row"
          (click)="expandedElement = expandedElement === row ? null : row" style="cursor: pointer;">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>


      </table>

      

      <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="100"
        [pageSizeOptions]="[25, 50, 100, 250]">
      </mat-paginator>
    </div>
  </nb-card-body>
 
</nb-card>